var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlBarGamepad = function SvgIconControlBarGamepad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.67 4c1.557 0 2.134 1.573 2.235 1.98.506 2.037 1.54 7.784 1.542 7.794.47 1.898-2.309 3.198-4.028 1.29l-1.323-1.98c-.15-.217-.426-.7-.87-.7H7.777c-.359 0-.657.482-.828.72l-1.361 1.96c-1.727 1.908-4.505.608-4.035-1.29l1.55-7.789C3.17 5.357 3.774 4 5.33 4zM6.499 6a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1v1a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V9h1a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5h-1v-1a.5.5 0 0 0-.5-.5zm7.002.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
  })));
};
export default SvgIconControlBarGamepad;